import { render } from "./TeamingTiptapTopic.vue?vue&type=template&id=cabd1cb4"
import script from "./TeamingTiptapTopic.vue?vue&type=script&lang=js"
export * from "./TeamingTiptapTopic.vue?vue&type=script&lang=js"

import "./TeamingTiptapTopic.vue?vue&type=style&index=0&id=cabd1cb4&lang=scss"
script.render = render

export default script